/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Locale} from '../models/Locale';

export interface GetAccountLocale$Request {
    accountId: number;
}

export interface GetAccountLocale$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountLocaleRequest = createAction<PayloadData<void, GetAccountLocale$Request>>('GET_ACCOUNT_LOCALE__GET_ACCOUNT_LOCALE__REQUEST');
export const getAccountLocaleSuccess = createAction<PayloadData<Locale, GetAccountLocale$Request>>('GET_ACCOUNT_LOCALE__GET_ACCOUNT_LOCALE__SUCCESS');
export const getAccountLocaleFailure = createAction<PayloadData<Error, GetAccountLocale$Request, true>>('GET_ACCOUNT_LOCALE__GET_ACCOUNT_LOCALE__FAILURE');

export const getAccountLocaleActions = [
    getAccountLocaleRequest,
    getAccountLocaleSuccess,
    getAccountLocaleFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountLocale = (meta: GetAccountLocale$Request, config?: GetAccountLocale$Config) => {
    return {
        CALL_API: {
            types: getAccountLocaleActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/locales`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

